import AuthLayout from "components/auth/AuthLayout";
import Layout from "layout/Layout";
import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

const Auth = lazy(() => import("../components/auth/AuthLayout"));
const Dashboard = lazy(
  () => import("../components/views/admin/dashboard/DashboardLayout"),
);
// const SetSecurityAnswers = lazy(
//   () => import("../components/auth/forgot/SetSecurityAnswers"),
// );
const Exam = lazy(() => import("../components/views/admin/exam/Exam"));
const GenerateCandidateKey = lazy(
  () => import("../components/views/admin/candidatekey/GenerateCandidateKey"),
);
const PdfGenerationRequest = lazy(
  () => import("../components/views/admin/subject/PdfGenerationRequest"),
);
const Subject = lazy(() => import("../components/views/admin/subject/Subject"));
const SheetsData = lazy(
  () => import("../components/views/admin/sheets/Sheets"),
);

const Sheets = lazy(
  () => import("../components/views/examiner/sheetwise/Sheets"),
);
const AnswerSheets = lazy(
  () => import("../components/views/examiner/sheetwise/AnswerSheets"),
);
const AssignedQuestions = lazy(
  () => import("../components/views/examiner/questionwise/AssignedQuestions"),
);

const HeaderExaminerAssignedQuestions = lazy(
  () =>
    import("../components/views/examiner/head_examiner/AssignedQuestions_uppsc"),
);
const HeaderExaminerModeration = lazy(
  () =>
    import("../components/views/examiner/head_examiner/moderation/Moderation"),
);

const HdmerModerationSelection = lazy(
  () =>
    import("../components/views/examiner/head_examiner/moderation/ModerationSelection"),
);
const HdmerModerationEvaluation = lazy(
  () =>
    import("../components/views/examiner/head_examiner/moderation/ModerationEvaluation"),
);
const HdmerModerationOveriew = lazy(
  () =>
    import("../components/views/examiner/head_examiner/moderation/ModerationOverview"),
);
const ViewOptionalQuestionSheets = lazy(
  () =>
    import("../components/views/examiner/head_examiner/optional_question/ViewOptionalQuestionSheets"),
);
const SheetsConfiguration = lazy(
  () => import("../components/views/admin/sheets/SheetsConfiguration"),
);

const ModelAnswer = lazy(
  () => import("../components/views/admin/modelAnswer/ModelAnswer"),
);
const ExaminerReconsideration = lazy(
  () =>
    import("../components/views/examiner/questionwise/ExaminerReconsideration"),
);
const Evaluation = lazy(
  () => import("../components/views/examiner/sheetwise/Evaluation"),
);
const QuestionEvaluation = lazy(
  () => import("../components/views/examiner/questionwise/QuestionEvaluation"),
);
const CheckType = lazy(() => import("../components/views/examiner/CheckType"));
const GenericEvaluation = lazy(
  () => import("../components/views/examiner/sheetwise/GenericEvaluation"),
);
const Error404 = lazy(() => import("../components/error/Error404"));
const Groups = lazy(() => import("../components/views/admin/groups/Groups"));
const Marks = lazy(() => import("../components/views/admin/marks/Marks"));
const MarksReport = lazy(
  () => import("../components/views/admin/marks/MarksReport"),
);
const GroupStudents = lazy(
  () => import("../components/views/admin/groups/GroupStudents"),
);
const GenerateReport = lazy(
  () => import("../components/reports/GenerateReport"),
);
const Questions = lazy(
  () => import("../components/views/admin/questions/Questions"),
);
const Maintainance = lazy(() => import("../components/error/Maintainance"));

const Sets = lazy(() => import("../components/views/admin/sets/Sets"));
const Examiner = lazy(
  () => import("../components/views/admin/examiner/Examiner"),
);
const FileUpload = lazy(
  () => import("../components/views/admin/sheets/FileUpload"),
);
const GenerateMachine = lazy(
  () => import("../components/views/admin/WorkstationMachine/GenerateMachine"),
);

const Workstations = lazy(
  () => import("../components/views/admin/WorkstationMachine/Workstations"),
);
const Examiners = lazy(
  () => import("../components/views/examiner/head_examiner/Examiners"),
);
const HeadExaminerEvaluation = lazy(
  () =>
    import("../components/views/examiner/head_examiner/HeadExaminerEvaluation"),
);
const EvaluatedSheets = lazy(
  () => import("../components/views/examiner/head_examiner/EvaluatedSheets"),
);
const ViewCandidateSheet = lazy(() => import("utils/ViewCandidateSheet"));
const ExaminerDashboardLayout = lazy(
  () => import("../components/views/admin/dashboard/ExaminerDashboardLayout"),
);
const CandidateOptionalQuestionMapping = lazy(
  () =>
    import("../components/views/examiner/head_examiner/optional_question/CandidateOptionalQuestionMapping"),
);
const CandidateSheetPreview = lazy(
  () =>
    import("../components/views/examiner/section_officer/CandidateSheetPreview"),
);
const HeadSet = lazy(
  () => import("../components/views/examiner/head_examiner/mapping/HeadSet"),
);
const ExaminerStaus = lazy(
  () =>
    import("../components/views/examiner/head_examiner/mapping/ExaminerStatus"),
);
const ExaminerGroup = lazy(
  () =>
    import("../components/views/examiner/head_examiner/mapping/ExaminerGroups"),
);
const QuestionBreak = lazy(
  () => import("../components/views/examiner/questionBreak/QuestionEvaluation"),
);

function DashboardRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        {/* 🔐 SuperAdmin Only */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/exams" element={<Exam />} />
        <Route path="/subjects" element={<Subject />} />
        <Route path="/sets" element={<Sets />} />
        <Route path="/configure-question" element={<Questions />} />
        <Route path="/sheets-data" element={<SheetsData />} />
        <Route path="/bulk-upload" element={<FileUpload />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/students" element={<GroupStudents />} />
        <Route path="/examiner" element={<Examiner />} />
        <Route path="/model-answer" element={<ModelAnswer />} />
        <Route path="/marks" element={<Marks />} />
        <Route path="/generate-report" element={<GenerateReport />} />
        <Route path="/generate-marks-report" element={<MarksReport />} />
        <Route path="/generate-workstation" element={<GenerateMachine />} />
        <Route path="/workstations" element={<Workstations />} />
        <Route
          path="/generate-candidate-key"
          element={<GenerateCandidateKey />}
        />
        <Route path="/pdf-requests" element={<PdfGenerationRequest />} />
        <Route path="/answer-sheets" element={<AnswerSheets />} />
        <Route path="/es" element={<EvaluatedSheets />} />
        {/* 🧑‍🏫 Examiner Only */}
        <Route path="/questions" element={<AssignedQuestions />} />
        <Route path="/reconsider" element={<ExaminerReconsideration />} />
        {/* 👨‍🏫 HeadExaminer Only */}
        <Route path="/examiners" element={<Examiners />} />
        <Route path="/he-set" element={<HeadSet />} />
        <Route path="/examiner-group" element={<ExaminerGroup />} />
        <Route path="/examiner-status" element={<ExaminerStaus />} />
        <Route
          path="/he-questions"
          element={<HeaderExaminerAssignedQuestions />}
        />
        <Route path="/he-evaluation" element={<HeadExaminerEvaluation />} />
        <Route path="/he-moderation" element={<HeaderExaminerModeration />} />
        <Route path="/selection" element={<HdmerModerationSelection />} />
        <Route path="/mod_evaluation" element={<HdmerModerationEvaluation />} />
        <Route path="/mod_overview" element={<HdmerModerationOveriew />} />
        <Route path="/oq-sheet" element={<ViewOptionalQuestionSheets />} />
        {/* 🧑‍🏫👨‍🏫 Examiner & HeadExaminer */}
        <Route
          path="/examiner-dashboard"
          element={<ExaminerDashboardLayout />}
        />
        <Route path="/question-evaluation" element={<QuestionEvaluation />} />
        {/* 🔐👨‍🏫 SuperAdmin & HeadExaminer */}
        <Route
          path="/oq-mapping"
          element={<CandidateOptionalQuestionMapping />}
        />
        {/* 📋 SectionOfficer Only */}
        <Route path="/cs-listing" element={<CandidateSheetPreview />} />
        {/* 🔐📋 SuperAdmin & SectionOfficer */}
        <Route path="/vcs" element={<ViewCandidateSheet />} />
        {/* 👥 Shared (All Roles) */}
        <Route path="/change-password" element={<Auth />} />
        {/* <Route path="/rsa" element={<SetSecurityAnswers />} /> */}
        <Route path="/404" element={<Error404 />} />
        <Route path="/maintainance" element={<Maintainance />} />
        {/* ⚠️ No Permissions Defined (Add to ROUTE_PERMISSIONS if needed) */}
        {/* Sheetwise evaluation */}
        <Route path="/sheets" element={<Sheets />} />{" "}
        {/* Check whether sheet type or question type evaluation */}
        <Route path="/check" element={<CheckType />} />
        {/* Extra - no use till now */}
        <Route path="/sheet-configuration" element={<SheetsConfiguration />} />
        {/* Extra - no use for uppsc */}
        <Route path="/evaluation" element={<Evaluation />} />
        {/* Generic evaluation - no use for uppsc */}
        {/* <Route path="/evaluate" element={<GenericEvaluation />} /> */}
        <Route path="/" element={<AuthLayout />} />
        <Route path="/evaluate" element={<QuestionBreak />} />
      </Route>
    </Routes>
  );
}

export default DashboardRoutes;
